import React from 'react';
export function BeautifullyRetro() {
  return <section className="bg-[#FFB5C5] py-24 px-4 md:px-8 overflow-hidden" data-id="element-38">
      <div className="container mx-auto" data-id="element-39">
        <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-12" data-id="element-40">
          <div className="md:w-1/2 text-center md:text-left" data-id="element-41">
            <h2 className="text-5xl md:text-7xl font-bold mb-8 text-[#1a1a1a] leading-tight" data-id="element-42">
              Beautifully <br data-id="element-43" />
              <span className="text-white drop-shadow-md" data-id="element-44">Retro</span>
            </h2>
            <p className="text-lg md:text-xl text-gray-800 mb-8 max-w-lg mx-auto md:mx-0" data-id="element-45">
              Our phones are authentic vintage rotary telephones, lovingly
              restored and modified with modern recording technology. They look
              and feel just like the originals because they are.
            </p>
            <div className="inline-block bg-white/30 backdrop-blur-md px-6 py-3 rounded-full border border-white/50" data-id="element-46">
              <span className="font-bold text-[#1a1a1a]" data-id="element-47">
                Authentic 1970s Hardware
              </span>
            </div>
          </div>

          <div className="md:w-1/2 flex justify-center relative" data-id="element-48">
            <div className="relative w-full max-w-[500px]" data-id="element-49">
              <img src="https://cdn.magicpatterns.com/uploads/wob26sewQx6vCX6UjusxTL/pasted-image.jpg" alt="Vintage retro items collection" className="w-full h-auto rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-50" />
            </div>
            {/* Decorative elements */}
            <div className="absolute top-0 right-10 w-20 h-20 bg-yellow-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob" data-id="element-51"></div>
            <div className="absolute bottom-0 left-10 w-20 h-20 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000" data-id="element-52"></div>
          </div>
        </div>
      </div>
    </section>;
}